import SageButton from "kit/SageButton";
import React from "react";

interface Props {
    accountLink: sage.model.IStripeAccountLink;
}

const BalanceMoneyCreateTransferConnect: React.FC<Props> = ({
    accountLink,
}) => {
    const onConnect = React.useCallback(() => {
        window.location.href = accountLink.url;
    }, [accountLink]);

    return (
        <div>
            <h4>Setup Stripe Connect to Transfer Balances</h4>
            <SageButton text="Connect" onClick={onConnect} />
            <p>
                If you have any questions, please reach out to
                anthonymdito@gmail.com
            </p>
        </div>
    );
};

export default BalanceMoneyCreateTransferConnect;
